import * as React from "react";
import {IReduxState} from "../reducers";
import {connect} from "react-redux";
import {endTimer, getUnSignedDoc, getLatestLoanOpp} from "consent/actions";
import {imageBaseUrl} from "config";
import {ConsentBox} from "consent/utils/consentBox";
import RoundedButton from "components/roundedButton";
import {partnerOfferings} from "login/config";
import Flashcard from "myshubhlife-component/Flashcard";
import {MessageType} from "utils/variables";

interface IConnectProps {
    dispatch?: (action: any) => void;
    unsignedDocument: string;
    userId: number;
    utm_source: string;
    esignRequestId: string;
    lenderOpportunityId: string;
}

interface IState {
    time: number;
}
let timer = null;
class TimerDelay extends React.Component<IConnectProps, IState> {
    constructor(props) {
        super(props);
        this.state = {
            time: 60,
        };
        this.handleOnBtnClick = this.handleOnBtnClick.bind(this);
    }
    public componentDidMount() {
        if (this.props.esignRequestId && !this.props.unsignedDocument) {
            this.props.dispatch(getUnSignedDoc(this.props.esignRequestId));
        } else {
            this.props.lenderOpportunityId && this.props.dispatch(getLatestLoanOpp(this.props.lenderOpportunityId));
        }
        this.startTimer();
    }

    public startTimer() {
        timer = setInterval(() => {
            if (this.state.time !== 0 && !this.props.unsignedDocument) {
                this.setState({
                    time: this.state.time - 1,
                });
                if (this.state.time !== 0 && this.state.time % 5 === 0 && !this.props.esignRequestId) {
                    this.props.lenderOpportunityId && this.props.dispatch(getLatestLoanOpp(this.props.lenderOpportunityId));
                }
                if (this.state.time !== 0 && this.state.time % 10 === 0) {
                    this.props.esignRequestId && this.props.dispatch(getUnSignedDoc(this.props.esignRequestId));
                }
            } else {
                this.props.esignRequestId && !this.props.unsignedDocument && this.props.dispatch(getUnSignedDoc(this.props.esignRequestId));
                clearInterval(timer);
            }
        }, 1000);
    }
    public handleOnBtnClick() {
        this.props.dispatch(endTimer());
    }
    public render() {
        return (
            <ConsentBox>
                {this.state.time > 0 ?
                    <div className="flex-column-center-row" style={{marginTop: 86}}>
                        <>
                            <div className="flex-center" style={{fontSize: 14, fontWeight: "bold"}}>Please wait a while</div>
                                <div style={{marginTop: 10, marginLeft: 11}}>
                                    <img src={partnerOfferings[this.props.utm_source]?.loaderImage ? partnerOfferings[this.props.utm_source]?.loaderImage : `${imageBaseUrl}/img/consent/processing.png`}
                                        alt="Thank You"
                                        style={{width: 108, height: 108}}/>
                                </div>
                            <div style={{fontSize: 14, textAlign: "center", marginTop: 16, marginBottom: 24}}>
                                {this.state.time > 0 && !this.props.unsignedDocument ? "We are generating your Loan Agreement" : "Loan Agreement Generated"}
                            </div>
                            <RoundedButton bgColor={partnerOfferings[this.props.utm_source]?.colors?.green} buttonText={`${this.state.time} sec`} size="small" />
                        </>
                    </div> :
                    <div className="flex-column-center-row">
                        <Flashcard
                            heading="ERROR"
                            description="Your loan agreement generation has failed, for further support"
                            supportText="Please contact us on"
                            supportEmail={true}
                            messageType={MessageType.ERROR}
                            supportEmailText={partnerOfferings[this.props.utm_source]?.supportEmail}
                        />
                    </div>
                }
            </ConsentBox>
        );
    }
}

const mapStateToProps = (state: IReduxState): IConnectProps =>  {
    return {
        unsignedDocument: state.consent.unsignedDocBase64Str,
        lenderOpportunityId: state.consent.lenderOpportunityId,
        userId: state.login.auth.userId,
        utm_source: state.login.authExt && state.login.authExt.utm_source ? state.login.authExt.utm_source : null,
        esignRequestId: state.consent.loanApprovalInfo ? state.consent.loanApprovalInfo.esignRequestId : null,
    };
};
export default connect<IConnectProps, {}, {}>(mapStateToProps)(TimerDelay);
